<svg xmlns="http://www.w3.org/2000/svg" width="115.56" height="104.6" viewBox="0 0 115.56 104.6">
  <defs>
    <style>
      .cls-1 {
        fill: #c1c1c1;
        fill-opacity: 0.4;
        stroke: #fff;
        stroke-linecap: square;
        stroke-linejoin: bevel;
        stroke-width: 6px;
        stroke-dasharray: 24 12;
        fill-rule: evenodd;
      }
    </style>
  </defs>
  <path id="autorynok" class="cls-1" d="M2726,6114l-65-45-47,54,18,29,46,16Z" transform="translate(-2611.91 -6067.06)"/>
</svg>
